import { crudActionConstantsGenerator } from './crud_action_constants_generator';
import { crudActionCreatorsGenerator } from './crud_action_creators_generator';

export const WORK_ORDER_ATTRIBUTES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('WORK_ORDER_ATTRIBUTES');
export const WORK_ORDER_ATTRIBUTES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	WORK_ORDER_ATTRIBUTES_CRUD_ACTION_CONSTANTS
);
